export const FETCH_DELEGATION_LIST_BEGIN = "FETCH_DELEGATION_LIST_BEGIN";
export const FETCH_DELEGATION_LIST_SUCCESS = "FETCH_DELEGATION_LIST_SUCCESS";
export const FETCH_DELEGATION_LIST_ERROR = "FETCH_DELEGATION_LIST_ERROR";

export const FETCH_EMPLOYEE_DELEGATION_LIST_BEGIN = "FETCH_EMPLOYEE_DELEGATION_LIST_BEGIN";
export const FETCH_EMPLOYEE_DELEGATION_LIST_SUCCESS = "FETCH_EMPLOYEE_DELEGATION_LIST_SUCCESS";
export const FETCH_EMPLOYEE_DELEGATION_LIST_ERROR = "FETCH_EMPLOYEE_DELEGATION_LIST_ERROR";

export const POST_CHECK_EMPLOYEE_DELEGATION_BEGIN = "POST_CHECK_EMPLOYEE_DELEGATION_BEGIN";
export const POST_CHECK_EMPLOYEE_DELEGATION_SUCCESS = "POST_CHECK_EMPLOYEE_DELEGATION_SUCCESS";
export const POST_CHECK_EMPLOYEE_DELEGATION_ERROR = "POST_CHECK_EMPLOYEE_DELEGATION_ERROR";

export const POST_ADD_EMPLOYEE_DELEGATION_LIST_BEGIN = "POST_ADD_EMPLOYEE_DELEGATION_LIST_BEGIN";
export const POST_ADD_EMPLOYEE_DELEGATION_LIST_SUCCESS =
  "POST_ADD_EMPLOYEE_DELEGATION_LIST_SUCCESS";
export const POST_ADD_EMPLOYEE_DELEGATION_LIST_ERROR = "POST_ADD_EMPLOYEE_DELEGATION_LIST_ERROR";

export const POST_EDIT_EMPLOYEE_DELEGATION_LIST_BEGIN = "POST_EDIT_EMPLOYEE_DELEGATION_LIST_BEGIN";
export const POST_EDIT_EMPLOYEE_DELEGATION_LIST_SUCCESS =
  "POST_EDIT_EMPLOYEE_DELEGATION_LIST_SUCCESS";
export const POST_EDIT_EMPLOYEE_DELEGATION_LIST_ERROR = "POST_EDIT_EMPLOYEE_DELEGATION_LIST_ERROR";

export const POST_REVOKE_DELEGATION_BEGIN = "POST_REVOKE_DELEGATION_BEGIN";
export const POST_REVOKE_DELEGATION_SUCCESS = "POST_REVOKE_DELEGATION_SUCCESS";
export const POST_REVOKE_DELEGATION_ERROR = "POST_REVOKE_DELEGATION_ERROR";

export const CLEAR_SEARCH_DELEGATION_DATA = "CLEAR_SEARCH_DELEGATION_DATA";



// WEBPACK FOOTER //
// ./actions/delegationActionTypes.js